import {
  REQUEST_HEALTH_DATA,
  HEALTH_DATA_FAILED,
  HEALTH_DATA_SUCCESS,
} from '../actions/types';

export const healthReducers = (
  state = {
    loading: true,
  },
  action,
) => {
  switch (action.type) {
    case REQUEST_HEALTH_DATA:
      return { loading: true };
    case HEALTH_DATA_SUCCESS:
      return { loading: false, data: action.payload };
    case HEALTH_DATA_FAILED:
      return { loading: false };
    default:
      return state;
  }
};
